import { preferenceStore } from '@hrms/common/component/user-preference/store';
import { removeUserPreferenceFromLocalStorage } from '@hrms/common/component/user-preference/utils';
import {
  APPLICATION_ID,
  AUTH_URL,
  PARENT_APPLICATION_ID,
} from '@hrms/common/constant/global';
import { recentTabsStore } from '@hrms/common/store/recentTabsStore';
import AuthTokenManager from './token';
import {
  AuthFetchTokenInterface,
  AuthIsLoggedInInterface,
  AuthLogoutInterface,
} from './types';

class AuthService extends AuthTokenManager {
  public static getAuthToken: AuthFetchTokenInterface = () => {
    const currentToken = AuthTokenManager.getToken();
    return currentToken && currentToken.length ? currentToken : null;
  };

  public static isLoggedIn: AuthIsLoggedInInterface = () => {
    const currentToken = AuthService.getAuthToken();
    return !!(currentToken && currentToken.length > 0);
  };

  public static expireToken = () => {
    AuthTokenManager.expireToken();
  };

  public static logout: AuthLogoutInterface = (message?: string) => {
    this.expireToken();

    let url = `${AUTH_URL}/login?parentApplicationId=${PARENT_APPLICATION_ID}&applicationId=${APPLICATION_ID}`;
    if (message) {
      url = url + `&message=${message}`;
    }
    try {
      const { preference, setPreferenece } = preferenceStore.getState();
      if (!preference?.checked) {
        removeUserPreferenceFromLocalStorage();
        setPreferenece(undefined);
      }
    } catch (error) {
      console.error('Error:: ', 'Fetching the preference :: ', error);
    }
    try {
      const { setRecentTabs } = recentTabsStore.getState();
      setRecentTabs([]);
    } catch (error) {
      console.error('Error:: ', 'while clearing the tabs ', error);
    }
    window.location.href = `${url}&referrer=${window.location.pathname}`;
  };
}

export default AuthService;
